import { render, staticRenderFns } from "./vc-async-loading.vue?vue&type=template&id=af6ad4aa&scoped=true&"
import script from "./vc-async-loading.vue?vue&type=script&lang=js&"
export * from "./vc-async-loading.vue?vue&type=script&lang=js&"
import style0 from "./vc-async-loading.vue?vue&type=style&index=0&id=af6ad4aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6ad4aa",
  null
  
)

export default component.exports